import { IStoreState, ThunkDispatch } from '../modules';
import React, { Component } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import Enrollment from './common/enrollment';
import { Typography } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { logout } from '../modules/auth';
import { proxyBase } from '../modules/config';
import { push } from 'connected-react-router';

const styles = (theme: Theme) => createStyles({
  root: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(2),
  },
}
)

type State = {
}

class EnrollContainer extends Component<Props, State> {
  render() {
    const { auth, classes, push, proxyBase } = this.props;

    if (!auth.authenticated) {
      return <Redirect to={proxyBase('/')} />
    }

    return (
      <div className={classNames(classes.root, 'maxWidth')}>
        <Typography style={{ marginBottom: '1rem' }}>To further protect your identity, we have put in security enhancements and made some changes to our account login. This adds a layer of protection around your account, as an additional level of security.</Typography>
        <Enrollment showLogout={true} next={() => push(proxyBase('/bind'))} />
      </div>
    )
  }
}



const mapStateToProps = ({ auth, intl }: IStoreState) => ({
  auth,
  intl,
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      push,
      logout,
      proxyBase
    }, dispatch
  )

interface MatchParams {
  url: string;
}

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, RouteComponentProps<MatchParams> {

}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EnrollContainer));